<!-- <template>
	<div class="full" style="box-sizing: border-box;padding: 10px;">
		<vxe-grid :ref="moduleName+'_list'" v-bind="gridOptions" @toolbar-button-click="toolbarButtonClickEvent"
			:loading="loading"></vxe-grid>
	</div>
</template> -->
<script>
	import listBase from '@_system/components/base/list.vue'
	import Static from './static/index.vue'
	import Reinvoice from './reinvoice/index.vue'
	// import Demo from '@/views/demo/index.vue'
	export default {
		extends: listBase,
		// props: {
		// 	foreingKey: {
		// 		type: Object,
		// 		default: () => {
		// 			return {
		// 				mode: 'detail'
		// 			}
		// 		}
		// 	}
		// },
		render(h) {
			this.$slots.header = [ <
				div style = "position: relative;width: 100%;height:100%" >
				<
				Static list = {
					this
				}
				ref = "invoicecustomerorderStatic" / >
				<
				/div>, <
				Reinvoice ref = "invoicecustomerorderReinvoice" / >

			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				loading: false,
				auditShow: true,
				moduleName: 'invoicecustomerorder',
				windowName: '自动开票',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			reinvoice() {

			},
			clearerror() {
				this.$confirm("清空错误单据?<br/>错误类型:<br/>来自售后的订单无法开票", '提示', {
					dangerouslyUseHTMLString: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.invoicecustomerorder.clearerror().then(() => {
						this.$message.success('操作成功')
						this.customreload()
						this.loading = false
					}, () => {
						this.loading = false
					})
				}).catch(() => {

				})
			},
			beforeRender() {
				this.$refs.invoicecustomerorderStatic.static()
			},
			file(row) {
				if (row.invoiceurl) {
					window.open(row.invoiceurl)
					return
				}
				if (row.status != 3) {
					this.$message.error('开票未成功')
				} else {
					this.$message.error('文件未下载')
				}
			},
			sendemail(row) {
				this.$confirm('确认发送发票文件?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.invoicecustomerorder.sendemail(row.id).then(() => {
						this.$message.success('操作成功')
						this.customreload()
						this.loading = false
					}, () => {
						this.loading = false
					})
				}).catch(() => {

				})

			},
			batchadd() {
				if (this.windowType == 'window') {
					// 		let res = this.$router.resolve({
					// 			name: 'add',
					// 			query: {
					// 				name: this.moduleName,
					// 				id: 0,
					// 				controlltype: 1,
					// 				windowName: '新建' + this.windowName,
					// 			}
					// 		})
					// 		let win = window.open(res.href, this.moduleName + 'add',
					// 			this.$store.state.system.windowConfig)
					// 		win.onload = () => {

					// 		}
				} else {
					import('@/components/forms/finance/invoicecustomerorder/batchadd/form.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: 'invoicecustomerorderbatch',
							id: 0,
							controlltype: 1,
							show: true,
							extra: {
								title: "批量添加"
							}
						}
					})
				}
			},
			reversal(row) {
				this.$confirm('是否确认冲红?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api[this.moduleName].reversal(row.id).then(() => {
						this.$message.success('操作成功')
						this.customreload()
						this.loading = false
					}, () => {
						this.loading = false
					})
				}).catch(() => {

				})

			},
			repair(row) {
				this.$api[this.moduleName].repair(row.id).then(() => {
					this.$message.success('操作成功')
					this.customreload()
					this.loading = false
				}, () => {
					this.loading = false
				})
			}
			// initList() {
			// 	this.operateButtonList = [{
			// 		code: 'invoice',
			// 		content: '开票',
			// 		status: 'success',
			// 		icon: 'vxe-icon-envelope',
			// 		inrow: true,
			// 	}, {
			// 		code: 'invoicepdf',
			// 		content: '文件',
			// 		status: '',
			// 		icon: 'vxe-icon-file-pdf',
			// 		inrow: true,
			// 	}]
			// 	this.initOperateButton()
			// 	this.initOption()
			// 	console.log(this.operateInrowButton)
			// },
			// toolbarButtonClickEvent(e) {
			// 	if (e.code == 'setcookie') {
			// 		alert('抓取开发中')
			// 	}
			// 	if (e.code == 'invoice') {
			// 		let data = this.$refs[this.moduleName + '_list'].getCheckboxRecords()
			// 		if (data.length != 0) {
			// 			let postdata = []
			// 			data.forEach((item) => {
			// 				if (item.status == '未开票') {
			// 					postdata.push(item.id)
			// 				}
			// 			})
			// 			this.electronicInvoice(postdata)
			// 		}
			// 	}
			// },
			// operateButtonClickEvent(e) {
			// 	if (e.code == 'invoice') {
			// 		if (e.data.status === '未开票' || e.data.status === '待开票') {
			// 			this.$confirm('是否确认开票 ', '提示', {
			// 				confirmButtonText: '确定',
			// 				cancelButtonText: '取消',
			// 				type: 'warning'
			// 			}).then(() => {
			// 				this.electronicInvoice([e.data.id])
			// 			}).catch(() => {

			// 			})

			// 		} else {
			// 			this.$message.error('状态不为未开票或待开票')
			// 		}
			// 	}
			// 	if (e.code == 'invoicepdf') {
			// 		if(e.data.invoiceurl){
			// 			window.open(e.data.invoiceurl)
			// 		}else{
			// 			this.$message.error('文件未下载')
			// 		}
			// 	}
			// 	console.log(e)
			// },
			// electronicInvoice(ids) {
			// 	this.loading = true
			// 	this.$api[this.moduleName].electronicInvoice({
			// 		ids: ids
			// 	}).then(() => {
			// 		this.loading = false
			// 		this.customreload()
			// 	}, () => {
			// 		this.loading = false
			// 	})
			// },

		},
		components: {

		}
	}
</script>